import React, { useContext, useEffect, useState } from 'react';
import { ContentChart } from '@meteor/frontend-core';
import { AppContext } from '../../../../contexts/AppContext';
import { cloneDeep, isArray, isObject, isString } from 'lodash';
import ErrorBoundary from '../../../common/error-boundary';

const SeriesDataChart: React.FC<any> = (props) => {
  const { echartTheme, setGlobalEvent } = useContext(AppContext);
  const { property, tooltips = ['zoomIn'] } = props;
  const [options, setOptions] = useState<any>(null);

  useEffect(() => {
    if (!property || !property.chartOptions) {
      return;
    }
    const arrowFunctionRegex = /^\s*\(?\s*([^)]*)\s*\)?\s*=>\s*{[^]*}$/;
    const reviver = (key, value) => {
      if (typeof value === 'string' && (value.startsWith('function') || arrowFunctionRegex.test(value))) {
        return new Function('return ' + value)();
      }
      return value;
    };
    if (typeof property.chartOptions.options === 'string') {
      try {
        const op = JSON.parse(property.chartOptions.options, reviver);
        setOptions(cloneDeep({ ...op, echartTheme }));
      } catch (error) {
        console.error(error);
        setOptions(cloneDeep({ ...property.chartOptions.options, echartTheme }));
      }
    } else {
      const parseFunction = (opts) => {
        for (const key in opts) {
          if (Object.prototype.hasOwnProperty.call(opts, key)) {
            if (isArray(opts[key])) {
              opts[key].forEach((item) => {
                parseFunction(item);
              });
            } else if (isObject(opts[key])) {
              parseFunction(opts[key]);
            } else if (isString(opts[key]) && (opts[key].startsWith('function') || arrowFunctionRegex.test(opts[key]))) {
              opts[key] = new Function('return ' + opts[key])();
            } else {
              // skip
            }
          }
        }
        return opts;
      };
      setOptions(cloneDeep({ ...parseFunction(property.chartOptions.options), echartTheme }));
    }
  }, [property]);

  return (
    <ErrorBoundary>
      {options ? (
        <ContentChart
          title={{
            value: <></>,
            styles: { display: 'none' },
          }}
          opts={{ renderer: 'canvas' }}
          contentList={[]}
          chartOptions={options}
          showSeriesLabel={false}
          mouseWheelZoomLock={false}
          loading={false}
          height={'100%'}
          tooltips={tooltips}
          isBank={false}
          onChartEvent={setGlobalEvent}
        />
      ) : (
        <></>
      )}
    </ErrorBoundary>
  );
};

export default SeriesDataChart;
